"use strict";
angular.module('publicLibraryCategoryServiceModule', [
        'publicLibraryCategoryNewCategoryModule', 
    ])
    .factory('publicLibraryCategoryService', ['$modal', '$q', function($modal, $q) {
        return {
            newPublicLibraryCategory: function(data) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/publicMaterialLibrary/service/newCategory/newCategory_tpl.html',
                    windowClass: 'public-material-library-new-category',
                    controller: 'publicLibraryCategoryNewCategoryCtrl',
                    backdrop: false,
                    resolve: {
                        Params: function() {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                });
                return defer.promise;
            }
        };
    }]);